export default __webpack_public_path__ + "static/media/cylinder-icon.097745c7.svg";